module.exports = __webpack_public_path__ + "static/media/xslego-1-cover.a66f110f.png";